export enum CouponSubCategory {
  free_coupon = 40001, // 免配券
  allotment_coupon = 40002, // 减配券
}

export enum CouponReminderInfoType {
  payment_restriction = 1, // 支付渠道限制
  payment_user_version_old = 2, // 支付渠道限制的券在低版本不可用
}

export enum PreUseCouponStatus {
  coupon_unuseable = 0, // 券不可用
  coupon_useable = 1, // 券可用
}

// 折扣类型
export enum CouponDiscountCategory {
  discount = 2, // 满折
}

/**
 * 页面来源
 */
export enum PageSourceType {
  MY_COUPON_LIST = 1, // 我的券列表
  ORDER_COUPON_LIST = 2, // 提单券列表
  HISTORY_COUPON_LIST = 3, // 历史券列表
}

/** 优惠券归属的券包类型 */
export enum CouponPackType {

  /** 发放券包 */
  ISSUE = 0,

  /** 售卖券包 */
  SELL = 2,
}

/** 售卖渠道(和后端保持一致) */
export enum SaleChannel {

  /** 高达 */
  Gundam = 1,

  /** 非搭售-门店页-售卖入口 */
  POI_PAGE_ENTRANCE = 2,

  /** 非搭售-门店页-半浮层弹窗 */
  POI_PAGE_HALF_FLOAT = 3,

  /** 搭售-填单页 */
  FILL_ORDER_PAFE = 4,

  /** 搭售-券列表页 */
  COUPON_LIST_PAGE = 5,

  /** 个人中心-券列表页 */
  PERSON_COUPON_LIST_PAGE = 9,
}

/** 膨后券类型(与后端保持一致) */
export enum InflateCouponType {

  /** 非膨后券 */
  NORMAL = 0,

  /** 膨后券 */
  INFLATED = 1,
}
